// extracted by mini-css-extract-plugin
export default {"creditDays":"customerQuickForm_creditDays__mZucV"};